import { Button } from "antd";
import ImageGrid from "./ImageGrid";
import QuestionMark from "../../../../common/components/QuestionMark";

import { useSelector, useDispatch } from "react-redux";
import generatorThunk from "../../redux/thunks";

const GeneratorContent = () => {
  const dispatch = useDispatch();
  const category = useSelector((state) => state.generator.selectedCategory);

  const handleGenerateClick = () => {
    dispatch(generatorThunk.getGeneratedImages(15, category));
  };

  return (
    <div className="generator-content">
      <div className="generator-left-container">
        <ImageGrid imageAmount={15} />
        <div style={{ paddingRight: "1rem", paddingTop: "3rem" }}>
          <Button
            onClick={() => {
              handleGenerateClick();
            }}
            style={{ backgroundColor: "#447CE9", border: "none" }}
            type="primary"
            size="large"
          >
            Generate
          </Button>
        </div>
      </div>
      <QuestionMark />
      <style jsx>{`
        .generator-content {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          padding: 3%;
        }
        .generator-left-container {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-end;
        }
        .generator-right-container {
          width: 60%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
      `}</style>
    </div>
  );
};
export default GeneratorContent;
